import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { Tabs, TabsProps } from "antd";
import { GetHardware } from "../service/AIapi";
import { setIsTabs } from "../store/library_slice";

import SoundConversion from "./SoundConversion";
import SoundSynthesis from "./SoundSynthesis";
import SoundCopy from './SoundCopy';
import ASR from "./ASR";
import RunningDevice from "../components/RunningDevice/RunningDevice";
import Customization from "./Customization";

import background from '../assets/bg/bg.webp';

const SpeechEntry = (): React.ReactElement => {
  const dispatch = useDispatch();
  const desc = '丰富领先的 AI 语音能力，在线体验产品，感受智能语音交互。';
  const [deviceName, setDeviceName] = useState('');
  const [activeTab, setActiveTab] = useState('speech');
  const minorMode = useSelector((state: any) => state?.guard?.minorMode);
  useEffect(() => {
    GetHardware().then(res => {
      setDeviceName(res.device)
    }).catch(error => {
      if (error.message === "Request failed with status code 504" || error.message === "Request failed with status code 502") {
        alert('获取设备失败：\n    1、如果目前服务正在启动，请稍后再试。\n    2、如果持续此状态超过3分钟，请参考使用说明书进行排查。')
      } else {
        alert('未知错误: ' + JSON.stringify(error));
      }
    })
  }, [])

  const items: TabsProps['items'] = [
    { key: 'speech', label: '语音合成', children: <SoundSynthesis /> },
    { key: 'conversion', label: '音色转换', children: <SoundConversion />, disabled: minorMode },
    { key: 'recognition', label: '语音识别', children: <ASR />, disabled: minorMode },
    { key: 'copyVoice', label: '声音复刻', children: <SoundCopy />, disabled: minorMode },
    { key: 'customization', label: '精品声音定制', children: < Customization /> },
  ];

  const tabsChange = (e: string) => {
    setActiveTab(e)
    dispatch(setIsTabs(e))
  }

  useEffect(() => {
    if (minorMode && ['conversion', 'recognition', 'copyVoice'].includes(activeTab)) {
      setActiveTab('speech');
      dispatch(setIsTabs('speech'));
    }
  }, [activeTab, dispatch, minorMode]);
  const runningDeviceStyles = {
    borderRadius: '2px',
    opacity: 1,
    border: ' 0.5px solid #FF671D',
    fontSize: '14px',
    color: '#FF671D',
    padding: ' 3px 6px 4px 3px',
    background: ' rgba(255, 0, 0, 0)',
    fontWeight: 200,
    textAlign: 'center'
  }
  return (
    <Frame>
      <InnerFrame style={{ zIndex: 1 }}>
        <Title>
          <span>摩尔线程 AI 语音技术 </span>
          <div style={{ marginLeft: '6px' }}>
            <RunningDevice style={runningDeviceStyles} device={deviceName}></RunningDevice>
          </div>
        </Title>
        <DescText dangerouslySetInnerHTML={{ __html: desc }} />
        <Tabs
          centered
          activeKey={activeTab}
          items={items}
          className='tabs'
          indicator={{ size: 20, align: 'center' }}
          onChange={e => tabsChange(e)}
        />
      </InnerFrame>
    </Frame>
  );
};

export default SpeechEntry;


const Title = styled.span`
  font-size: 24px;
  color: #222222;
  font-weight: 600;
  display: flex;
  align-items: center;
`

const DescText = styled.span`
  font-size: 16px;
  color: #444444;
  line-height: 28px;
  margin-top: 20px;
  font-weight: normal;
  height: 100%;
`

const InnerFrame = styled.div`
  width: 1000px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 60px 0 30px 0;
`

const Frame = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  align-items: center;
  background: url(${background}) ;
  background-repeat: no-repeat;
  background-position: center center; /* 将背景图片居中 */
  background-size: cover; /* 将背景图片等比缩放以填充整个容器 */
`
